// Imported EAGERLY, not `lazy`: the server renders the pager, so its scroller and slots are already in the
// document, and a `<Suspense fallback={<Outlet/>}>` that resolves after hydration re-parents the whole route
// subtree into the scroller — remounting every pane and dropping its state (a typed search box, an open menu,
// a drag in flight). Splitting it costs the first interaction on every page.

import { ScrollTransitionOutlet } from './scroll-transition-outlet'
import type { TransitionOutletProps } from './surface.config'

export function TransitionOutlet(props: TransitionOutletProps) {
  return <ScrollTransitionOutlet {...props} />
}
